import Waybills from './index.vue'
export default Waybills